import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import Card from "@/components/Atoms/Card";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const RightSection = styled(FlexDiv)`
  flex-direction: column;
  align-items: center;
  width: 50%;
  position: relative;
  @media only screen and (max-width: 1079px) {
    width: 100%;
  }
`;

export const RightSectionWrapper = styled(FlexDiv)`
  @media only screen and (min-width: 600px) {
    position: sticky;
    top: 138px;
  }
`;

export const FormCard = styled(Card)`
  max-width: 554px;
  display: flex;
  flex-direction: column;
  margin: 0;
  height: max-content;
  border-radius: 30px;
  @media only screen and (max-width: 1079px) {
    max-width: unset;
    border-radius: 16px;
    max-width: 335px;
  }
`;

export const FormHeader = styled(FlexDiv)`
  align-items: center;
  gap: 20px;
  padding: 40px 48px;
  background: #d7ecfa;
  svg {
    height: 106px;
    width: 106px;
  }
  @media only screen and (max-width: 600px) {
    padding: 24px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    svg {
      height: 70px;
      width: 70px;
    }
  }
`;

export const HeaderText = styled(Typography)`
  flex: 1;
  width: 332px;
  color: #282828;
  font-size: 48px;
  line-height: 53px;
  font-family: var(--forum);
  font-style: normal;
  font-weight: 400;
  @media only screen and (max-width: 600px) {
    // text-align: center;
    color: #282828;
    font-size: 32px;
    font-family: var(--forum);
    font-style: normal;
    font-weight: 400;
    line-height: 35px;
  }
`;

export const FormContent = styled(FlexDiv)`
  flex-direction: column;
  align-items: center;
  padding: 0px 32px;
  margin: 32px 0px;
  @media only screen and (max-width: 600px) {
    gap: 16px;
    padding: 24px 16px;
    margin: 0px 0px;
    button {
      margin-top: 8px !important;
    }
  }
`;

export const FormTitle = styled(Typography)`
  font-family: var(--mori);
  text-align: center;
  color: #282828;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 32px;
  @media only screen and (max-width: 600px) {
    color: #282828;
    text-align: center;
    font-size: 14px;
    font-family: var(--mori);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0px;
  }
`;

export const FormMessage = styled(Typography)`
  font-family: var(--mori);
  padding: 0px 32px;
  color: #576be3;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 32px;

  @media only screen and (max-width: 600px) {
    color: #576be3;
    text-align: center;
    font-size: 14px;
    font-family: var(--mori);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const InputContainer = styled(FlexDiv)`
  width: 100%;
  flex-direction: column;
  gap: 16px;

  input {
    padding: 8px 32px !important;
    border-radius: 47px !important;
  }
`;

export const HeaderContentBox = styled(FlexDiv)`
  flex-direction: column;
  margin-top: 32px;
  gap: 8px;
  align-items: center;

  @media only screen and (min-width: 650px) {
    display: none;
  }
`;

export const Heading = styled(Typography)`
  color: #282828;
  text-align: center;
  font-size: 32px;
  line-height: 35px;
  font-family: var(--forum);
  font-style: normal;
  font-weight: 400;
`;

export const ContentText = styled(Typography)`
  color: #293056;
  text-align: center;
  font-size: 14px;
  font-family: var(--mori);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 32px;
`;

export const IconImage = styled.img`
  height: 106px;
  width: 106px;
  mix-blend-mode: multiply;
  object-fit: cover;
  @media only screen and (max-width: 600px) {
    height: 70px;
    width: 70px;
  }
`;
